import React from 'react';
import { Row } from 'react-bootstrap';
import { childrenWithProps } from '../../../../helper/reactChildsWithProps';

export interface Props {
  children?: any;
  className?: string;
  required?: boolean;
}

export default function FAQContainerHOC({
  children,
  className,
  ...props
}: Props): React.ReactElement {
  return (
    <Row
      {...props}
      className={`${className ?? ''} choice-container-hoc w-100
      )}`}
    >
      {childrenWithProps(children, { required: props.required })}
    </Row>
  );
}
